import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../controller/OppStatusController/CreateOppuStatusController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";

function CreateOppSource({ OpportunityStatus, onClose, onSuccess }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({ vc_Name: '',Sort:"0" });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }

    useEffect(() => {
        if (OpportunityStatus) {
            setFormData({
                vc_Name: OpportunityStatus.vc_Name,
                Sort:OpportunityStatus.Sort
            });
        } else {
            setFormData({ vc_Name: '',Sort:"0" }); // Clear form data when switching to add mode
        }
    }, [OpportunityStatus]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit =async (event) => {
        event.preventDefault(); // Prevent default form submission
        if (OpportunityStatus) {
            formData.ID = OpportunityStatus.ID;
        } else {
            formData.ID = 0;
        }
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
       
        const postData = await handleSubmit(event, formData, setFormData, setErrors);
        onSuccess();
    };

    return (
        <div>
            <form onSubmit={handleFormSubmit}>
            <div className="modal fade opportunitySourceModal show d-block" id="opportunitySourceModal" tabIndex="-1" aria-labelledby="opportunitySourceModalLabel" aria-hidden="true" data-backdrop="static">
               
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">{OpportunityStatus ? "Edit Status" : "Add Status"}</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">

                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Name:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="vc_Name" value={formData.vc_Name} onChange={handleFieldChange} />
                                        {errors.vc_Name && <div style={{ color: 'red' }}>{errors.vc_Name}</div>}
                                    </div>
                                     <label htmlFor="inputText" className="col-sm-2 col-form-label">Sort:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="Sort" value={formData.Sort} onChange={handleFieldChange} />
                                        {errors.Sort && <div style={{ color: 'red' }}>{errors.Sort}</div>}
                                    </div>

                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">
                                    <i className="icofont-save" aria-hidden="true"> {OpportunityStatus ? " Update" : " Save"}</i>
                                </button>
                                <button className="btn btn-secondary" type="button" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                    <i className="icofont-close" aria-hidden="true"> Close</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

        </div>
    );
}

export default CreateOppSource;